<template lang="pug">
div
  v-row.match-height
    v-col
      v-card(:loading="busy")

        provider-action-bar(
          v-bind="$props"
          :set="set"
          :row="row"
          @refresh="refresh"
          @goto="goto"
          @perform="perform"
        )

        //- FORMULARIO
        v-card-text
          provider-form(
            v-bind="$props"
            :set="set"
            :row="row"
          )

  //- Diálogo de confirmação de operação
  action-dialog(
    v-bind="$props"
    :request="request"
    @actionComplete="refresh()"
    @actionTerminate="request = null"
  )
</template>

<script>
import ActionDialog from '@/components/commons/action-dialog/ActionDialog'

import ProviderActionBar from './ProviderActionBar'
import ProviderForm from './ProviderForm'

export default {
  components: {
    ActionDialog,

    ProviderActionBar,
    ProviderForm,
  },

  props: {
    site: String,
    eref: String,
    form: Object,
    data: Object,
    entity: Object,

    busy: Boolean,
  },

  data: () => ({
    /**
     * Registros selecionados na grade.
     * @type {Object}
     *    Format:
     *    {
     *      -- Link da requisição
     *      link: {Keep.Paper.Design.Link}
     *      -- Registros afetados pela requisição.
     *      selection: {Array}
     *    }
     */
    request: null, // Parâmetros de requisição
  }),

  computed: {
    title: vm => vm.entity?.title || vm.entity?.name || vm.entity?.eref,
    description: vm => vm.entity?.description,

    forms: vm => vm.entity.forms || [],

    set: vm => vm.entity?.dataSet?.sets[0] || {},
    rows: vm => vm.set?.rows || [],
    total: vm => vm.rows.length,
    index: vm => vm.rows.indexOf(vm.row),
    browsable: vm => vm.total > 1,

    row: vm => vm.rows.filter(vm.isSelected)[0] || vm.rows[0],

    color: vm => vm.row?.['@row']?.style?.toLowerCase(),

    // fields: vm => vm.edit.fields || [],
    // links: vm => vm.edit.links || [],
    // actions: vm => findRels(vm.links, 'Action'),

    // row: vm => vm.set?.rows[0] || {},
  },

  methods: {
    refresh () {
      this.$emit('refresh', { noCache: true, dataSetOnly: true })
    },

    perform (opts) {
      // TODO: FIXME: Substituir pelo novo: @/helpers/actions/performAction()
      const link = opts.link
      const rules = opts.link.rule || []
      const browse = rules.somw(rule => rule === 'Browse')
      if (browse) {
        this.$go(link)
      } else {
        this.request = opts
      }
    },

    goto (index) {
      const { browsable, total, rows, setSelected } = this

      if (!browsable) return
      if (index < 0 || index >= total) return

      // limpando selecao atual
      rows.forEach(row => setSelected(row, null))

      // selecionando alvo se ainda existir
      setSelected(rows[index], true)
    },

    isSelected (row) {
      return row['@row']?.selected
    },
    setSelected (row, value) {
      const cell = row['@row']
      if (cell) {
        this.$set(cell, 'selected', value)
      }
    },

    getCellValue (cell) {
      return typeof cell === 'object' ? cell?.value : cell
    },
  },
}
</script>
